// libs
import React from "react";

// types
import { SideMenuEntry } from "@defs/Sidemenu";
import { ISimulationInput } from "@defs/Utilities";
import { InputType } from "@utils/appsync/schema/API";

// constants
import { SIMULATION_INPUTS } from "@utils/constants";

// icons
import { AutoAwesomeOutlined, MenuBook } from "@mui/icons-material";

export const sideMenuItems: Array<SideMenuEntry> = [
    {
        label: "Control Plane",
        heading: true,
        hide: true,
    },
    {
        label: "Sandboxes",
        path: "/control-plane/sandboxes",
        hide: true,
    },
    {
        label: "Simulations",
        icon: <AutoAwesomeOutlined />,
        heading: true,
    },
    {
        label: "New Simulation",
        path: "/simulation",
    },
    {
        label: "Simulations History",
        path: "/simulations",
    },
    {
        label: "Shared Simulations",
        path: "/simulations/shared",
        divider: true,
    },
    {
        label: "Changes",
        heading: true,
        hide: true,
    },
    {
        label: "MCM Drafts",
        path: "/home",
        disabled: true,
        hide: true,
    },
    {
        label: "System Dictionary",
        heading: true,
        path: "",
        icon: <MenuBook />,
    },
    ...SIMULATION_INPUTS.map(
        (simulationInput: ISimulationInput<InputType>): SideMenuEntry => ({
            label: simulationInput.inputLabel,
            path: "/dictionary/" + simulationInput.inputKey,
        }),
    ),
    {
        label: "CostPools",
        path: "/costpools",
    },
];
